// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__0nx+H","light":"Logo_light__9jmVK"};